__turbopack_context__.v({
  "animation": "auth-trigger-module-scss-module__4UhWfq__animation",
  "fadeIn": "auth-trigger-module-scss-module__4UhWfq__fadeIn",
  "root": "auth-trigger-module-scss-module__4UhWfq__root",
  "slideDown": "auth-trigger-module-scss-module__4UhWfq__slideDown",
});
